import { render, staticRenderFns } from "./frequency-threshold.vue?vue&type=template&id=03511e6c&scoped=true&"
import script from "./frequency-threshold.vue?vue&type=script&lang=ts&"
export * from "./frequency-threshold.vue?vue&type=script&lang=ts&"
import style0 from "./frequency-threshold.vue?vue&type=style&index=0&id=03511e6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03511e6c",
  null
  
)

export default component.exports